import { useContext, useEffect, useState, useCallback } from "react";
import { useSearchParams } from 'react-router';
import debounce from 'lodash/debounce';
import {TextField, Autocomplete} from '@mui/material';
import uniqWith  from 'lodash/uniqWith';
import SearchIcon from '@mui/icons-material/Search';


import SearchContext from 'src/context/SearchContext';
import { queryJson, headers } from 'src/util/Util';

import "src/css/SearchBox.scss";

const ITEMS_EP = import.meta.env.VITE_ITEMS_EP;

export const hit2suggestions = (hit) => {
    const parser = new DOMParser()
    let entries = hit.highlight ? Object.entries(hit.highlight) : [];
    entries = entries.filter(([k, v]) => (v + '').split(' ').length < 4);
    let sugg = entries.map(([k, v]) => parser.parseFromString(v, "text/html").documentElement.textContent);

    return sugg;
}

const autocomplete = async (query, filters) => {
    query = query?.trim()

    let body = queryJson({query, filters, size: 30, isSearch: true})
    let res;
    let suggestions;

    let url = `${ITEMS_EP}_search`;
    try {
        let docs = await (await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(body),
        }))?.json()
        // res = await axios.post(BASE_DOCS + ITEMS, body)
        // suggestions = uniqWith(res.data.hits.hits.map(hit2suggestions).flat(), (a,b) => a.toLowerCase() === b.toLowerCase()).slice(0, 10);
        suggestions = uniqWith(docs.hits.hits.map(hit2suggestions).flat(), (a,b) => a.toLowerCase() === b.toLowerCase()).slice(0, 10);
    } catch (e) {
        /* handle error */
        suggestions = [];
        console.log(e);
    }
    // console.log('sugerencias', suggestions.join(' | '));
    return suggestions;
}

const SearchBox = () => {
    const { updateParams } = useContext(SearchContext);
    const [ searchParams ] = useSearchParams();
    const [ query, setQuery ] = useState(searchParams.get('query')?.trim() || '');
    const [ suggestions, setSuggestions ] = useState([]);

    const updateSP = (query) => {
        if ((query || null) !== (searchParams.get('query') || null)) { // consideramos null = undefined = ''
            if (query) searchParams.set('query', query);
            else searchParams.delete('query');
            updateParams(searchParams);
        }
    }

    // https://stackoverflow.com/a/66652147
    const [ inputValue, setInputValue ] = useState("");
    const getOptionsDelayed = useCallback(
        debounce((text, callback) => {
            setSuggestions([]);
            autocomplete(text).then(callback);
        }, 250),
        []
    );
    useEffect(() => {
        getOptionsDelayed(inputValue, (filteredOptions) => {
            setSuggestions(filteredOptions);
        });
    }, [ inputValue, getOptionsDelayed ]);

    const hChange = (ev, query, reason) => {
        if (reason != 'clear') {
            updateSP(query);
        }
    }

    useEffect(() => {
        setQuery(searchParams.get('query')?.trim() || '');
    }, []);

    useEffect(() => {
        setQuery(searchParams.get('query')?.trim() || '');
    }, [searchParams]);

    const renderInput = (params) => (
        <TextField {...params}
            name='query'
            placeholder="Buscar..."
            inputProps={{
                ...params.inputProps,
                onKeyDown: (e) => {
                    // hack, autocomplete lanza onChange cuando se limpia la cadena, queremos que lo haga en el enter
                    if (e.key === 'Enter' && !e.target.value) {
                        updateSP(e.target.value)
                    }
                },
            }}
        />
    );

    return (
        <div id="search-box" className="search-box">
            <Autocomplete
                options={suggestions}
                renderInput={renderInput}
                autoComplete
                clearOnEscape
                disablePortal
                filterOptions={(x) => x} // you will need to disable the built-in filtering
                forcePopupIcon={false}
                freeSolo
                id='search-prompt'
                noOptionsText="No se encontró ninguna sugerencia"
                onChange={hChange}
                onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
                value={query}
            />

            {/* <i className="search icon lupa" onClick={() => updateSP()}></i> */}
            <SearchIcon className="search icon lupa" onClick={() => updateSP(inputValue)}  />
        </div>
    );
};

export default SearchBox;
